import { render, staticRenderFns } from "./SummaryLikesAndRepostsHeader.vue?vue&type=template&id=7370dede&"
import script from "./SummaryLikesAndRepostsHeader.vue?vue&type=script&lang=js&"
export * from "./SummaryLikesAndRepostsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SummaryLikesAndRepostsHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports